import { T } from '@tribeplatform/react-components/i18n'

export const PoweredByBettermode = () => {
  return (
    <T
      defaultMessage="<small>Powered by</small><logo-wrapper>{BRAND}</logo-wrapper>"
      id="RESERVED.Branding.PoweredBy"
      values={{
        small: chunks => <span className="text-xs me-1">{chunks}</span>,
        'logo-wrapper': chunks => (
          <>
            <HoverableBettermodeLogo />
            <span className="text-xs ms-1 font-medium">{chunks}</span>
          </>
        ),
      }}
    />
  )
}

const HoverableBettermodeLogo = () => {
  // putting css directly into svg gives syntax error
  const css = `
      #logo-bg {
        fill: #98A2B3;
        transition: all 0.1s ease-out;
      }
      .group:hover #logo-bg {
        fill: #86CB3C;
      }

      #logo-toggle {
        transform: translateX(0);
        transition: all 0.1s ease-out;
      }
      .group:hover #logo-toggle {
        transform: translateX(10px);
      }
`
  return (
    <svg
      width="24"
      height="15"
      viewBox="0 0 24 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      id="bettermode-logo-animated"
    >
      <style>{css}</style>

      <g clipPath="url(#clip0_1117_346575)">
        <rect
          y="0.95459"
          width="24"
          height="13.0909"
          rx="6.54545"
          id="logo-bg"
        />
        <circle cx="6.90906" cy="7.5" r="5" fill="white" id="logo-toggle" />
      </g>
      <defs>
        <clipPath id="clip0_1117_346575">
          <rect
            y="0.95459"
            width="24"
            height="13.0909"
            rx="6.54545"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
